import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { collection, getDocs, query, orderBy, limit } from 'firebase/firestore';
import { db } from '../firebase';
import './RecomendacionesDestacadas.css';

function RecomendacionesDestacadas({ maxItems = 3 }) {
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategorias = async () => {
      try {
        const categoriasCollection = collection(db, 'recomendaciones');
        const q = query(categoriasCollection, orderBy('orden', 'asc'), limit(maxItems));
        const querySnapshot = await getDocs(q);
        
        const categoriasData = querySnapshot.docs.map(doc => {
          const data = doc.data();
          // Check if 'nombre' exists and provide a fallback
          if (!data.nombre) {
            console.warn(`Category with ID ${doc.id} is missing 'nombre' field in RecomendacionesDestacadas`);
            data.nombre = `Categoría ${doc.id}`;
          }
          return {
            id: doc.id,
            ...data
          };
        });
        
        console.log("Fetched featured categories:", categoriasData);
        setCategorias(categoriasData);
      } catch (err) {
        console.error("Error al cargar categorías destacadas:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchCategorias();
  }, [maxItems]);

  if (loading) {
    return <div className="recomendaciones-destacadas-loading">Cargando actividades...</div>;
  }

  if (categorias.length === 0) {
    return null; // No mostrar nada si no hay categorías
  }

  return (
    <div className="recomendaciones-destacadas">
      <div className="categorias-destacadas-grid">
        {categorias.map(categoria => {
          // Ensure the category name has a fallback value
          const nombreDisplay = categoria.nombre || `Categoría ${categoria.id}`;
          
          return (
            <Link 
              to={`/recomendaciones/${categoria.id}`} 
              key={categoria.id} 
              className="categoria-destacada-card"
            >
              <div className="categoria-destacada-image">
                <img 
                  src={categoria.imagenes && categoria.imagenes.length > 0 
                    ? categoria.imagenes[0] 
                    : 'https://via.placeholder.com/300x200?text=Actividad'} 
                  alt={nombreDisplay}
                />
              </div>
              <h3 className="categoria-nombre">{nombreDisplay}</h3>
            </Link>
          );
        })}
      </div>
    </div>
  );
}

export default RecomendacionesDestacadas; 